import { unflatten } from 'flat';
import Validator from '../../../../components/forms/validate';

const RULES = {
	'approvedFirmwareVersion': ['required']
};

const CUSTOM_MESSAGES = {
	'required.approvedFirmwareVersion': 'Choose or type the firmware version to approve'
};

/*
 * One required field, and no blank guard beyond `required`: this project's validatorjs is a Syneto
 * fork whose `required` already rejects "   " and "\t\n", so a hand-written whitespace check here
 * would be unreachable. The behaviour is pinned by a test instead, so a fork change that loosened
 * `required` fails loudly rather than letting whitespace reach a version column that is compared
 * for exact equality against what appliances report.
 *
 * There is deliberately no rule relating the version to the type's advisories. Nothing stops HITS
 * approving a version an active advisory lists as affected, and whether that should be rejected,
 * warned about, or left to the operator is an open behavioural decision (spec §13) - inventing a
 * rule here would settle it by accident.
 */
export const validateApproveFirmwareVersionForm = (values) => {
	const validator = new Validator(values, RULES, CUSTOM_MESSAGES);

	return validator.fails() ? unflatten(validator.errors.all()) : {};
};

export default validateApproveFirmwareVersionForm;
